









































import {Component, Vue} from "vue-property-decorator";
import MyList from "@/components/myList.vue";
import {getConfig, saveLangdingPage} from '@/services/api'
import store from "@/store";
import validator from "@/services/validatorNew";


@Component({
  components: {'my-list': MyList},
})
export default class StationAdd extends Vue{

  // 域名列表
  public domainList: {domain: string, pixel: string, path: string}[] = []
  // 模版列表
  public templateList: {templateId: number, templateName: string}[] = [{
    "templateId": 0,
    "templateName": "通用模版"
  }]

  // 表单信息
  public formData: {
    domain?: string,
    pixel?: string,
    path?: string,
    templateId?: number,
    templateName?: string,
    itemIds: any[],
    [props: string]: any
  } = {
    domain: "",
    pixel: "",
    path: "",
    templateId: 0,
    templateName: "",
    itemIds: []
  }

  // 验证规则
  private rules: {[key: string]:{required: boolean, requiredMsg?: string, reg?: RegExp, regMsg?: string, max?: number, maxMsg?: string, min?: number, minMsg?: string}}= {
    domain: {required: true, requiredMsg: '投放域名不能为空'},
    pixel: {required: true, requiredMsg: '像素不能为空', reg: /^[0-9a-zA-Z]*$/, regMsg: '像素格式不正确'},
    templateId: {required: true, requiredMsg: '投放模版不能为空'},
    itemIds: {required: true, requiredMsg: '关联产品不能为空'},
  }

  // 选择框展示
  public dialogVisible = false;

  /**
   * 初始化方法
   */
  created() {
    this.getConfig();
  }

  /**
   * 获取字典信息
   */
  getConfig(): void {
    if (!this.$store.state.domain || this.$store.state.domain.length === 0) {
      getConfig({type: 'domain'}).then(res => {
        if (res.data && res.data.status === 'OK') {
          this.domainList = res.data.result || [];
          store.commit('SET_DOMAIN', this.domainList);
        }
      })
    } else {
      this.domainList = this.$store.state.domain;
    }
  }

  /**
   * 上传
   */
  submit() {
    if(!this.checkForm()) {
      return;
    }
    for (let domain of this.domainList) {
      if (this.formData.domain === domain.domain) {
        this.formData.path = domain.path;
        // this.formData.pixel = domain.pixel;
      }
    }
    for (let template of this.templateList) {
      if (this.formData.templateId === template.templateId) {
        this.formData.templateName = template.templateName;
      }
    }
    saveLangdingPage(this.formData, true).then(res => {
      if (res.data && res.data.status === 'OK') {
        this.$message.success('保存成功')
        this.$router.push('/station/list');
      } else {
        this.$message.error(res.data.body.message);
      }
    }).catch(() => {})
  }

  /**
   * 校验表单内容是否通过
   */
  checkForm(): boolean {
    for (let key of Object.keys(this.rules)) {
      if(!validator(this.rules[key], this.formData[key], (msg: string) => {
        this.$message.error(msg);
      })) {
        return false;
      }
    }
    return true;
  }

  /**
   * 关闭选择框
   */
  handleClose(): void {
    this.dialogVisible = false;
  }

  /**
   * 删除关联产品
   * @param itemIds
   * @param index
   */
  deleteItem(itemIds: any[], index: number): void {
    itemIds.splice(index, 1);
  }

  /**
   * 添加关联产品
   * @param selectedList
   */
  addItem(selectedList: any[]) {
    this.formData.itemIds.push(...selectedList.map(item => item.itemId));
    this.dialogVisible = false;
  }
}
